export default __webpack_public_path__ + "static/images/pattern-a602d4946b66c35a26b0dbef93df612e.png";